require('es6-promise').polyfill()
require('es6-shim')
require('imports?jQuery=jquery!bootstrap')
require('font-awesome-sass-loader')
import 'core-js/modules/es7.array.includes'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './components/App'

import router from './router'
import rootStore from './store'
import focus from 'vue-focus'

// コンポーネント詰め合わせhttp://element.eleme.io/#/en-US
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-default/index.css'

import * as Sentry from '@sentry/browser'

// 多言語対応
import vuexI18n from 'vuex-i18n'
import i18n from './i18n'

Vue.use(Vuex)

const store = new Vuex.Store(rootStore)
Vue.use(vuexI18n.plugin, store)

Vue.use(ElementUI, {locale})

// 設定可能言語
Vue.i18n.add('ja', i18n.ja)
// 使用言語
Vue.i18n.set('ja')

// 開発ツールを有効化
Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App },
  directives: { focus: focus }
})

Sentry.init({
  dsn: 'https://8ca4d114070047d3a4f1b64a2d6e2bec@sentry.io/1400035',
  integrations: [new Sentry.Integrations.Vue({
    Vue,
    attachProps: true
  })],
  environment: process.env.NODE_ENV
})



// WEBPACK FOOTER //
// ./src/main.js